
function ZeroToDashNumber(_number) {
	if (_number === 0 || _number === null || _number === undefined)
	{
		_number = '-';
	}

	return _number;
}

export default {
	name: 'JewishValueReport',
	handler: {
		init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		},
		update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
			var params = valueAccessor();

			var parsed_leave_value = params.leave_value();
			var parsed_jewish_value = params.jewish_value();
			var final_string = '';

			if (parsed_jewish_value == 0)
			{
				// theres no jewish leave taken
				final_string = ZeroToDashNumber(parsed_leave_value);
			} else
			{
				// there is jewish leave

				if (parsed_leave_value == 0)
				{
					// there was no non-jewish leave taken
					final_string = '[' + parsed_jewish_value + ' jewish]';
				} else
				{
					final_string = ZeroToDashNumber(parsed_leave_value) + ' + [' + parsed_jewish_value + ' jewish]';
				}
			}
			element.innerHTML = final_string;
		}
	}
};
